import { t } from 'i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteScheduledDeployment } from 'Services';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import { RQ_SCHEDULED_DEPLOYMENT, RQ_SCHEDULED_DEPLOYMENT_SUMMARY } from '@brighterion/utils/react-query-constants';
import type { ScheduledDeployment } from './useGetScheduledDeployment';

const useDeleteScheduledDeployment = (scheduledDeployment: ScheduledDeployment) => {
    const queryClient = useQueryClient();
    const { addAlert } = useAlertBanner();

    const handleOnSuccess = (data: ScheduledDeployment) => {
        const { version } = data;
        addAlert({
            id: 'scheduled-deployment-cancelled',
            status: 'success',
            content: t('scheduledDeployment.cancelled', { version })
        });
    };

    const handleOnError = () => {
        addAlert({
            id: 'scheduled-deployment-warning',
            status: 'warning',
            content: t('scheduledDeployment.error')
        });
    };

    return useMutation(deleteScheduledDeployment, {
        onSuccess: () => {
            handleOnSuccess(scheduledDeployment);
            queryClient.invalidateQueries([RQ_SCHEDULED_DEPLOYMENT]);
            queryClient.invalidateQueries([RQ_SCHEDULED_DEPLOYMENT_SUMMARY]);
        },
        onError: () => {
            handleOnError();
        }
    });
};

export default useDeleteScheduledDeployment;
